import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Header from '../../../chat/components/Header';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import OTVideoChat from '../../../shared/OTVideoChat';

const useStyles = makeStyles((theme) => ({
  chatbox: {
    backgroundColor: '#999',
    paddingBottom: 10,
  },
  formWrap: {
    backgroundColor: '#000000', // '#2196f3',
    margin: 5,
    position: 'relative',
    '& .wrap': {
      padding: 3,
    }
  },
  completed: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: 300,
    height: 100,
    marginTop: -50,
    marginLeft: -150,
    textAlign: 'center',
  }
}));

function renderHeader(props) {
    return (<Header profile={props.rep} actions={props.actions} />);
}


export default function VideoChat(props) {
  const classes = useStyles();

  let con = props.videoChatData;
  console.log("Jobseeker video chat: ", con);

  return (
    <div className={classes.chatbox}>
      {renderHeader(props)}
      <Paper className={classes.formWrap} elevation={3}>
        <div className='wrap' style={{visibility: (props.reviewSent ? 'hidden' : 'visible')}}>
          <div style={{ width: '100%', height: '55vh', minHeight: '320px'}}>
            { con.apiKey ? <OTVideoChat apiKey={con.apiKey} sessionId={con.sessionId} token={con.token} onEndCall={props.onEndCall} finished={props.finished} /> : null }
          </div>
        </div>
      </Paper>
    </div>
    );
}


